var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 5.125V18.875C2 19.9297 2.82031 20.75 3.875 20.75H20.125C21.1406 20.75 22 19.9297 22 18.875V5.125C22 4.10938 21.1406 3.25 20.125 3.25H3.875C2.82031 3.25 2 4.10938 2 5.125ZM20.4375 13.875H9.69531V10.125H20.4375V13.875ZM20.4375 15.4375V18.7188C20.4375 18.9922 20.2031 19.1875 19.9688 19.1875H9.69531V15.4375H20.4375ZM3.5625 10.125H8.13281V13.875H3.5625V10.125ZM9.69531 8.5625V4.8125H19.9688C20.2031 4.8125 20.4375 5.04688 20.4375 5.28125V8.5625H9.69531ZM8.13281 4.8125V8.5625H3.5625V5.28125C3.5625 5.04688 3.75781 4.8125 4.03125 4.8125H8.13281ZM3.5625 15.4375H8.13281V19.1875H4.03125C3.75781 19.1875 3.5625 18.9922 3.5625 18.7188V15.4375Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.68d4a95004289ef9c52f994bbdea0ed1.svg";
export { ForwardRef as ReactComponent };